import * as React from "react";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {formatMoney2}   from "@Common/ui-components/language/format-money";
import {LoadingSpinner} from "@Common/ui-components/photo-dashboard/components/loading-spinner";

import "./review-content.scss";

export const ReviewChangesContent = ({modal, activeSubscription, selectedDetails, ccInfo}) => cs(
    consumeContext("apis"),
    consumeContext("session"),
    ["agent", ({session}, next) => next(session?.data?.agent)],
    ["updatingSubscription", (_, next) => UseState({initValue: false, next})],
    ({apis, session, agent, updatingSubscription}) => (<>
        {updatingSubscription.value || ccInfo.loading ? (
            LoadingContent()
        ) : (
            <div className="review-content review-content-rc6m">
                <div className="content-container">
                    <div className="title">
                        {selectedDetails.deferredDate ? "Review Scheduled Changes" : "Review Changes"}
                    </div>
                    <div className="details-section">
                        <ul className="list">
                            <li className="list-item">
                                <div className="plan">Current Plan</div>
                            </li>
                            <li className="sub-list-item">
                                <div className="plan-description">
                                    XD+ {PERIOD_MONTHS_CONVERSION[activeSubscription.periodMonths]}
                                </div>
                                <div className="cost">{formatMoney2(activeSubscription.priceCents / 100)}</div>
                            </li>
                        </ul>
                        <div className="spacer"></div>
                        <ul className="list">
                            <li className="list-item">
                                <div className="plan">New Plan</div>
                            </li>
                            <li className="sub-list-item">
                                <div className="plan-description">
                                    XD+ {PERIOD_MONTHS_CONVERSION[selectedDetails.pricePoint.periodMonths]}
                                </div>
                                <div className="cost">{formatMoney2(selectedDetails.pricePoint.priceCents / 100)}</div>
                            </li>
                        </ul>
                        {selectedDetails.deferredDate && <div className="change-date">
                            This plan change will take place at the end of your current billing cycle ({new Date(activeSubscription.dateNextRenewal.date).toLocaleDateString('en-US', { day: '2-digit', month: 'short', year: 'numeric' })})
                        </div>}
                    </div>
                    <div className="total-cost-description-section">
                        <div className="total-cost-description">
                        {selectedDetails.deferredDate ? (
                            `You will be charged ${formatMoney2(selectedDetails.firstInvoice.totalCents / 100)} at the end of your current billing cycle via ${ccInfo.value?.type.toUpperCase()} ending in ${ccInfo.value?.last4}`
                        ) : (
                            `You will be charged ${formatMoney2(selectedDetails.firstInvoice.dueCents / 100)} for prorated charges via ${ccInfo.value?.type.toUpperCase()} ending in ${ccInfo.value?.last4} today`
                        )}
                        </div>
                    </div>
                    <div className="update-subscription-section">
                        <button 
                            className="update-subscription"
                            disabled={updatingSubscription.value}
                            onClick={async () => {
                                updatingSubscription.onChange(true)
                                await apis.next.subscription.updatePlan({idPricePoint: selectedDetails.pricePoint.id, idAgent: agent.idAgent})
                                await apis.next.subscription.sync()
                                await session.reload();
                            }}
                        >
                            Update Subscription   <span className="arrow">&#8594;</span>
                        </button>
                    </div>
                </div>
            </div>
        )}
    </>)
)

const PERIOD_MONTHS_CONVERSION = {
    1: "Monthly",
    3: "Quarterly",
    12: "Yearly",
}

const MONTHS_PERIOD_CONVERSION = {
    "Monthly": 1,
    "Quarterly": 3,
    "Yearly": 12,
}

const LoadingContent = () => (
    <div className="plan-loading-content-9s8d" xd-qa-type="label" xd-qa-name="Loading">
        <div className="content-container">
            <LoadingSpinner text="Updating Plan, Please Wait..."/>
        </div>
    </div>
)